// Original BMW 2010 colour swatches from the reference configurator.
export const BMW_2010_COLORS = [
  {
    "code": "9860",
    "n": "Piano Black",
    "h": "#0E0F12",
    "cat": "black"
  },
  {
    "code": "9800",
    "n": "Jet Black",
    "h": "#17181B",
    "cat": "black"
  },
  {
    "code": "9861",
    "n": "Raven",
    "h": "#1A1C20",
    "cat": "black"
  },
  {
    "code": "9836",
    "n": "Carbon Black",
    "h": "#1E2229",
    "cat": "black"
  },
  {
    "code": "9862",
    "n": "Shadow Grey",
    "h": "#23262A",
    "cat": "grey"
  },
  {
    "code": "9850",
    "n": "Charcoal",
    "h": "#282C2F",
    "cat": "grey"
  },
  {
    "code": "919-638",
    "n": "Slate",
    "h": "#2F3438",
    "cat": "grey"
  },
  {
    "code": "9854",
    "n": "Onyx",
    "h": "#303335",
    "cat": "grey"
  },
  {
    "code": "9851",
    "n": "Gunmetal",
    "h": "#353639",
    "cat": "grey"
  },
  {
    "code": "9853",
    "n": "Steel",
    "h": "#38393D",
    "cat": "grey"
  },
  {
    "code": "9852",
    "n": "Anthracite",
    "h": "#393B3F",
    "cat": "grey"
  },
  {
    "code": "919-639",
    "n": "Iron",
    "h": "#3A3D42",
    "cat": "grey"
  },
  {
    "code": "9845",
    "n": "Graphite",
    "h": "#3F4044",
    "cat": "grey"
  },
  {
    "code": "9830",
    "n": "Slate Grey",
    "h": "#3F4448",
    "cat": "grey"
  },
  {
    "code": "9863",
    "n": "Storm Grey",
    "h": "#44484D",
    "cat": "grey"
  },
  {
    "code": "919-640",
    "n": "Ash",
    "h": "#4B4C4E",
    "cat": "grey"
  },
  {
    "code": "9810",
    "n": "Basalt Grey",
    "h": "#53616C",
    "cat": "grey"
  },
  {
    "code": "919-641",
    "n": "Pewter",
    "h": "#58595C",
    "cat": "grey"
  },
  {
    "code": "919-642",
    "n": "Smoke",
    "h": "#666867",
    "cat": "grey"
  },
  {
    "code": "919-643",
    "n": "Granite",
    "h": "#757877",
    "cat": "grey"
  },
  {
    "code": "9864",
    "n": "Silver Grey",
    "h": "#8A8F92",
    "cat": "grey"
  },
  {
    "code": "9843",
    "n": "Mist Grey",
    "h": "#ADB7B3",
    "cat": "grey"
  },
  {
    "code": "9801",
    "n": "Moonlight White",
    "h": "#DCDED0",
    "cat": "white"
  },
  {
    "code": "9802",
    "n": "Ivory",
    "h": "#D3D3C5",
    "cat": "white"
  },
  {
    "code": "9803",
    "n": "Alpine White",
    "h": "#D7D4C1",
    "cat": "white"
  },
  {
    "code": "9804",
    "n": "Cream",
    "h": "#E0D9BE",
    "cat": "white"
  },
  {
    "code": "9837",
    "n": "Arctic White",
    "h": "#E3E9E4",
    "cat": "white"
  },
  {
    "code": "9805",
    "n": "Azalea",
    "h": "#CFC39D",
    "cat": "beige"
  },
  {
    "code": "9806",
    "n": "Almond",
    "h": "#BBAF82",
    "cat": "beige"
  },
  {
    "code": "9844",
    "n": "Sand",
    "h": "#B0A484",
    "cat": "beige"
  },
  {
    "code": "9847",
    "n": "Oat",
    "h": "#BFB8A6",
    "cat": "beige"
  },
  {
    "code": "919-604",
    "n": "Wheat",
    "h": "#B6A872",
    "cat": "beige"
  },
  {
    "code": "919-606",
    "n": "Stone",
    "h": "#B6B5A8",
    "cat": "beige"
  },
  {
    "code": "919-607",
    "n": "Greige",
    "h": "#ACAA93",
    "cat": "beige"
  },
  {
    "code": "9813",
    "n": "China Red",
    "h": "#AB2623",
    "cat": "red"
  },
  {
    "code": "9814",
    "n": "Flame Red",
    "h": "#A62824",
    "cat": "red"
  },
  {
    "code": "9815",
    "n": "Rust Red",
    "h": "#862F2B",
    "cat": "red"
  },
  {
    "code": "9816",
    "n": "Ruby Red",
    "h": "#772328",
    "cat": "red"
  },
  {
    "code": "9817",
    "n": "Bordeaux",
    "h": "#682829",
    "cat": "red"
  },
  {
    "code": "919-619",
    "n": "Wine",
    "h": "#771F1E",
    "cat": "red"
  },
  {
    "code": "9811",
    "n": "Saffron",
    "h": "#E87214",
    "cat": "orange"
  },
  {
    "code": "9812",
    "n": "Amber",
    "h": "#D75D1B",
    "cat": "orange"
  },
  {
    "code": "9818",
    "n": "Mustard",
    "h": "#BF853B",
    "cat": "yellow"
  },
  {
    "code": "919-633",
    "n": "Gold",
    "h": "#CCAB12",
    "cat": "yellow"
  },
  {
    "code": "9819",
    "n": "Ochre",
    "h": "#B4762C",
    "cat": "brown"
  },
  {
    "code": "9820",
    "n": "Earth Brown",
    "h": "#956128",
    "cat": "brown"
  },
  {
    "code": "9821",
    "n": "Khaki Brown",
    "h": "#A1632E",
    "cat": "brown"
  },
  {
    "code": "9822",
    "n": "Cognac",
    "h": "#A05A27",
    "cat": "brown"
  },
  {
    "code": "9823",
    "n": "Signal Brown",
    "h": "#8B5227",
    "cat": "brown"
  },
  {
    "code": "9848",
    "n": "Caramel",
    "h": "#995C2B",
    "cat": "brown"
  },
  {
    "code": "919-612",
    "n": "Tobacco",
    "h": "#7C5626",
    "cat": "brown"
  },
  {
    "code": "9824",
    "n": "Dark Brown",
    "h": "#5C3C27",
    "cat": "brown"
  },
  {
    "code": "9825",
    "n": "Walnut",
    "h": "#573C28",
    "cat": "brown"
  },
  {
    "code": "9826",
    "n": "Bitter Brown",
    "h": "#483628",
    "cat": "brown"
  },
  {
    "code": "919-622",
    "n": "Bark",
    "h": "#43312D",
    "cat": "brown"
  },
  {
    "code": "9846",
    "n": "Espresso",
    "h": "#422B24",
    "cat": "brown"
  },
  {
    "code": "9828",
    "n": "Taupe",
    "h": "#3B3127",
    "cat": "brown"
  },
  {
    "code": "9840",
    "n": "Coffee",
    "h": "#352C29",
    "cat": "brown"
  },
  {
    "code": "9827",
    "n": "Chocolate",
    "h": "#34231F",
    "cat": "brown"
  },
  {
    "code": "9807",
    "n": "Aqua Blue",
    "h": "#A4BDD6",
    "cat": "blue"
  },
  {
    "code": "9838",
    "n": "Azure",
    "h": "#309ED0",
    "cat": "blue"
  },
  {
    "code": "9808",
    "n": "Sky Blue",
    "h": "#1461AF",
    "cat": "blue"
  },
  {
    "code": "919-635",
    "n": "Steel Blue",
    "h": "#3D6D9D",
    "cat": "blue"
  },
  {
    "code": "919-634",
    "n": "Petrol",
    "h": "#195A7A",
    "cat": "blue"
  },
  {
    "code": "9809",
    "n": "Violet Blue",
    "h": "#1A305E",
    "cat": "blue"
  },
  {
    "code": "9839",
    "n": "Imperial Blue",
    "h": "#1D2A57",
    "cat": "blue"
  },
  {
    "code": "919-625",
    "n": "Midnight Blue",
    "h": "#242E60",
    "cat": "blue"
  },
  {
    "code": "9831",
    "n": "Grey Blue",
    "h": "#263240",
    "cat": "blue"
  },
  {
    "code": "9832",
    "n": "Ink Teal",
    "h": "#1B2839",
    "cat": "blue"
  },
  {
    "code": "9833",
    "n": "Deep Blue",
    "h": "#192440",
    "cat": "blue"
  },
  {
    "code": "9834",
    "n": "Diamond Blue",
    "h": "#112138",
    "cat": "blue"
  },
  {
    "code": "9835",
    "n": "Navy",
    "h": "#1A1D2C",
    "cat": "blue"
  },
  {
    "code": "9849",
    "n": "Aqua",
    "h": "#70C6BF",
    "cat": "green"
  },
  {
    "code": "919-636",
    "n": "Turquoise",
    "h": "#64BFBB",
    "cat": "green"
  },
  {
    "code": "919-602",
    "n": "Sage",
    "h": "#828A7E",
    "cat": "green"
  },
  {
    "code": "9829",
    "n": "Emerald",
    "h": "#274746",
    "cat": "green"
  },
  {
    "code": "9842",
    "n": "Plum",
    "h": "#472C46",
    "cat": "purple"
  }
];
